import { c as _c } from "react/compiler-runtime";
import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ApiWaveParticipationRequirement } from "@/generated/models/ApiWaveParticipationRequirement";
import CreateDropContentRequirementsItem from "./CreateDropContentRequirementsItem";
export enum DropRequirementType {
  MEDIA = "MEDIA",
  METADATA = "METADATA",
}
interface CreateDropContentRequirementsProps {
  readonly canSubmit: boolean;
  readonly wave: ApiWave;
  readonly missingMedia: ApiWaveParticipationRequirement[];
  readonly missingMetadata: string[];
  readonly disabled: boolean;
  readonly onOpenMetadata: () => void;
  readonly setFiles: (files: File[]) => void;
}
const CreateDropContentRequirements: React.FC<CreateDropContentRequirementsProps> = t0 => {
  const $ = _c(10);
  const {
    canSubmit,
    wave,
    missingMedia,
    missingMetadata,
    disabled,
    onOpenMetadata,
    setFiles
  } = t0;
  let t1;
  if ($[0] !== canSubmit || $[1] !== disabled || $[2] !== missingMedia || $[3] !== missingMetadata || $[4] !== onOpenMetadata || $[5] !== setFiles || $[6] !== wave) {
    t1 = canSubmit && (!!wave.participation.required_media.length || !!wave.participation.required_metadata.length) && <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -10
    }} transition={{
      duration: 0.3
    }} className="tw-mt-2 tw-w-full tw-inline-flex tw-space-x-2">{wave.participation.required_media.length > 0 && <CreateDropContentRequirementsItem isValid={!missingMedia.length} missingItems={missingMedia.map(_temp)} requirementType={DropRequirementType.MEDIA} onOpenMetadata={onOpenMetadata} setFiles={setFiles} disabled={disabled} />}{wave.participation.required_metadata.length > 0 && <CreateDropContentRequirementsItem isValid={!missingMetadata.length} missingItems={missingMetadata} requirementType={DropRequirementType.METADATA} onOpenMetadata={onOpenMetadata} setFiles={setFiles} disabled={disabled} />}</motion.div>;
    $[0] = canSubmit;
    $[1] = disabled;
    $[2] = missingMedia;
    $[3] = missingMetadata;
    $[4] = onOpenMetadata;
    $[5] = setFiles;
    $[6] = wave;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = <AnimatePresence>{t1}</AnimatePresence>;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default CreateDropContentRequirements;
function _temp(m) {
  return m.toLowerCase();
}